module.exports = __webpack_public_path__ + "img/pro-p-slider24.a3d6b4b4.png";